var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocalisationCommune(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_2680",
    "data-name": "Groupe 2680",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 70.073,
    viewBox: "0 0 74 70.073",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_104",
    "data-name": "Rectangle 104",
    width: 74,
    height: 70.073,
    fill: "#0d0b0e",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2555",
    "data-name": "Groupe 2555",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_883",
    "data-name": "Trac\\xE9 883",
    d: "M73.948,68.757l-12-36A1,1,0,0,0,61,32.073H59l-1,2h2.279l11.334,34H38V65.564a2.56,2.56,0,0,1,2.557-2.557H56.064a4.557,4.557,0,0,0,4.323-6l-.627-1.885a4.554,4.554,0,0,0-4.325-3.116H27.677a2.558,2.558,0,0,1-2.465-3.241l.279-1.009a2.563,2.563,0,0,1,2.456-1.875l13.043.125H41a.964.964,0,0,0,.16-.032.989.989,0,0,0,1.108-.209l12.824-12.9a19.355,19.355,0,0,0,0-27.22,19.055,19.055,0,0,0-27.067,0,19.356,19.356,0,0,0,0,27.22L39.082,43.988l-11.126-.106a4.571,4.571,0,0,0-4.392,3.34l-.28,1.011a4.558,4.558,0,0,0,4.393,5.774H55.435a2.554,2.554,0,0,1,2.427,1.748l.628,1.885a2.559,2.559,0,0,1-2.426,3.367H40.557A4.562,4.562,0,0,0,36,65.564v2.509H2.387l11.333-34H25l-1-2H13a1,1,0,0,0-.949.684l-12,36A1,1,0,0,0,1,70.073H73a1,1,0,0,0,.948-1.316M29.444,7.051a17.053,17.053,0,0,1,24.229,0,17.35,17.35,0,0,1,0,24.4L41.559,43.642,29.444,31.451a17.35,17.35,0,0,1,0-24.4",
    transform: "translate(0 0)",
    fill: "#0d0b0e",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_884",
    "data-name": "Trac\\xE9 884",
    d: "M50.618,19.274a9.06,9.06,0,1,0-2.653,6.407,9,9,0,0,0,2.653-6.407m-9.06,7.061a7.059,7.059,0,1,1,4.993-2.068,7.01,7.01,0,0,1-4.993,2.068",
    transform: "translate(0 0)",
    fill: "#0d0b0e",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalisationCommune);
export default __webpack_public_path__ + "static/media/localisation-commune.68e08297fef7bdd608a23e4e285d7865.svg";
export { ForwardRef as ReactComponent };